import React, { useState } from 'react';
import s from './s.module.less';
// import YouTubePlayer from 'components/YoutubePlayer';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import PaymentsCover from './images/paymentImage.png';
import cls from 'classnames';

interface IProps {
    setOnboardingPopupStep: (step: number) => void;
    onClosePopup: () => void;
    practiceAndPaymentSetUpCompleted?: boolean;
}

const Payments = ({
    setOnboardingPopupStep,
    onClosePopup,
    practiceAndPaymentSetUpCompleted,
}: IProps) => {
    const navigate = useNavigate();
    // const [play, setPlay] = useState(false);

    return (
        <div className={s.wrap}>
            <div className={s.playerBox}>
                <div className={s.player}>
                    <img src={PaymentsCover} alt="" />
                </div>
            </div>
            <div className={s.content}>

                <div className={cls(s.title, practiceAndPaymentSetUpCompleted && s.completeIcon)}>Set up how you get paid – define your practice and payment details</div>
                <div className={s.desc}>Provide your practice information and customize key billing policies like no-show, cancellation, and rescheduling fees. These details ensure you get paid on time and help reduce missed appointments.</div>
                <Button className={s.stepDirBtn} onClick={() => navigate(`/${PATH.PAYMENT_SETUP}`)}>Set up no-show policy</Button>

            </div>
            <div className={s.footer}>
                <div className={s.step}>Step 4 of 4</div>
                <div className={s.btns}>
                    <Button style={{ width: '120px' }} onClick={() => setOnboardingPopupStep(3)}>Previous</Button>
                    <Button style={{ width: '120px' }} type="primary" onClick={onClosePopup}>Finish</Button>
                </div>
            </div>
        </div>
    );
};

export default Payments;
